import { render, staticRenderFns } from "./No21.vue?vue&type=template&id=10b9f6f4&scoped=true"
import script from "./No21.vue?vue&type=script&lang=js"
export * from "./No21.vue?vue&type=script&lang=js"
import style0 from "./No21.vue?vue&type=style&index=0&id=10b9f6f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b9f6f4",
  null
  
)

export default component.exports